var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"input__icon icon icon--eye",attrs:{"tabindex":"-1"},on:{"click":_vm.maskPasswordToggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }